import request from '@/utils/request'
const Api = {
    CustomerSafe: '/Biz/Customer/safe',
    SendEditPasswordCode: '/Biz/Customer/sendEditPasswordCode',
    CustomerEditPwd: '/Biz/Customer/editPwd',
    SendEditPhoneCode: '/Biz/Customer/sendEditPhoneCode',
    EditPhone: '/Biz/Customer/editPhone',
    InfoList: '/Biz/Info/list',
    LoginLogList: '/Biz/Customer/loginLogList',
    FeedbackAdd: '/Biz/Feedback/add',
    CustomerView: '/Biz/Customer/view',
    CustomerSave: '/Biz/Customer/save',
    ImageAdd: '/Biz/Image/add'
}

/**
 * 安全信息
 * @returns 
 */
export function getCustomerSafe() {
    return request({
        url: Api.CustomerSafe,
        method: 'get',
    })
}
/**
 * 发送修改密码验证码
 * @returns 
 */
export function getSendEditPasswordCode() {
    return request({
        url: Api.SendEditPasswordCode,
        method: 'get',
    })
}

/**
 * 修改密码
 * @returns 
 */
export function getCustomerEditPwd(params) {
    return request({
        url: Api.CustomerEditPwd,
        method: 'post',
        data: params
    })
}

/**
 * 发送修改手机验证码
 * @returns 
 */
export function getSendEditPhoneCode(params) {
    return request({
        url: Api.SendEditPhoneCode,
        method: 'post',
        data: params
    })
}

/**
 * 修改手机号
 * @returns 
 */
export function getEditPhone(params) {
    return request({
        url: Api.EditPhone,
        method: 'post',
        data: params
    })
}

/**
 * 系统信息
 * @returns 
 */
export function getInfoList(params) {
    return request({
        url: Api.InfoList,
        method: 'get',
        params: params
    })
}

/**
 * 登录日志
 * @returns 
 */
export function getLoginLogList(params) {
    return request({
        url: Api.LoginLogList,
        method: 'get',
        params: params
    })
}
/**
 * 上传图片
 */
export function getImageAdd(parameter) {
    return request({
        url: Api.ImageAdd,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        method: 'post',
        data: parameter
    })
}
/**
 * 
 * @param {增加反馈} parameter 
 * @returns 
 */
export function getFeedbackAdd(parameter) {
    return request({
        url: Api.FeedbackAdd,
        method: 'post',
        data: parameter
    })
}
/**
 * 会员信息
 * @returns 
 */
export function getCustomerView() {
    return request({
        url: Api.CustomerView,
        method: 'get',
    })
}
/**
 * 保存会员信息
 * @returns 
 */
export function getCustomerSave(parameter) {
    return request({
        url: Api.CustomerSave,
        method: 'post',
        data: parameter
    })
}


// WEBPACK FOOTER //
// ./src/api/accountcenter.js